export default "__VITE_ASSET__tcfVyCWp__"